<pre-upload-files-modal>

    <dialog class="modal" ref="dialog" aria-labelledby="pre-upload-files-modal-heading">
        <div class="modal-box max-w-6xl">
            <form method="dialog">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}"
                        onclick="{handleCancel}">
                    <i class="icon-clear" aria-hidden="true"></i>
                </button>
            </form>

            <h3 id="pre-upload-files-modal-heading" class="font-bold text-lg mb-2 text-primary">{locale?.t('preupload_title')}</h3>
            <p class="text-sm text-gray-600 mb-4">
                {locale?.t('preupload_subtitle')}
            </p>

            <!-- Collection (applies to the entire upload batch) -->
            <div class="flex flex-wrap items-center gap-3 mb-6">
                <label id="preupload-collection-label" class="label-text font-semibold text-primary whitespace-nowrap">{locale?.t('collection')}:</label>
                <div class="w-full max-w-xs">
                    <single-select
                        list="{state.collections}"
                        idproperty="collectionId"
                        displayproperty="displayName"
                        selected="{state.selectedCollectionId}"
                        loading="{!state.collectionsLoaded}"
                        labelledby="preupload-collection-label"
                        fitcontent="{false}"
                        onupdated="{onCollectionSelected}">
                    </single-select>
                </div>
                <!-- Create New Collection button temporarily hidden (to be restored later); create-collection modal + saveNewCollection() left intact.
                <button type="button"
                        class="btn btn-primary btn-sm rounded-lg whitespace-nowrap"
                        onclick="{openCreateCollection}">
                    <i class="icon-add" aria-hidden="true"></i> {locale?.t('content_item_addcollection_create')}
                </button>
                -->
            </div>

            <!-- Metadata Table -->
            <div class="overflow-hidden border border-1 border-base-300 rounded-md">
                <div class="overflow-x-auto">
                    <table class="table">
                        <thead>
                            <tr class="text-accent border-b border-base-300">
                                <th class="px-3 py-2 text-white bg-primary font-semibold w-1/5">{locale?.t('filename')}</th>
                                <th class="px-3 py-2 text-white bg-primary font-semibold w-1/5">{locale?.t('title')}</th>
                                <th class="px-3 py-2 text-white bg-primary font-semibold w-1/5">{locale?.t('description')}</th>
                                <th class="px-3 py-2 text-white bg-primary font-semibold w-1/5">{locale?.t('externalsource')}</th>
                                <th class="px-3 py-2 text-white bg-primary font-semibold w-1/5">{locale?.t('externalid')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr each="{(item, index) in getCurrentPageItems()}" key="{item.name}" class="{index % 2 === 0 ? 'bg-base-200' : 'bg-white'} border-b border-base-300 last:border-b-0">
                                <td class="px-3 py-4 align-middle">
                                    <span class="text-sm break-all font-medium">{item.name}</span>
                                </td>
                                <td class="px-3 py-4 align-middle">
                                    <input
                                        type="text"
                                        class="input input-sm input-bordered bg-white w-full"
                                        aria-label="{locale?.t('title')}: {item.name}"
                                        value="{getMetadataValue(item.name, 'title')}"
                                        oninput="{(e) => updateMetadata(item.name, 'title', e.target.value)}"
                                    />
                                </td>
                                <td class="px-3 py-4 align-middle">
                                    <textarea
                                        class="textarea textarea-sm textarea-bordered bg-white w-full h-8 min-h-8 overflow-hidden leading-tight py-2"
                                        rows="1"
                                        aria-label="{locale?.t('description')}: {item.name}"
                                        value="{getMetadataValue(item.name, 'description')}"
                                        oninput="{(e) => updateMetadata(item.name, 'description', e.target.value)}"
                                    ></textarea>
                                </td>
                                <td class="px-3 py-4 align-middle">
                                    <input
                                        type="text"
                                        class="input input-sm input-bordered bg-white w-full"
                                        aria-label="{locale?.t('externalsource')}: {item.name}"
                                        value="{getMetadataValue(item.name, 'externalSource')}"
                                        oninput="{(e) => updateMetadata(item.name, 'externalSource', e.target.value)}"
                                    />
                                </td>
                                <td class="px-3 py-4 align-middle">
                                    <input
                                        type="text"
                                        class="input input-sm input-bordered bg-white w-full"
                                        aria-label="{locale?.t('externalid')}: {item.name}"
                                        value="{getMetadataValue(item.name, 'externalId')}"
                                        oninput="{(e) => updateMetadata(item.name, 'externalId', e.target.value)}"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Pagination -->
            <div class="mb-6">
                <pagination
                    if="{state.totalPages > 1}"
                    pagelength="{state.pageSize}"
                    pageindex="{state.currentPage}"
                    totalpages="{state.totalPages}"
                    hidepagelength="{true}"
                    onPageIndexChange="{changePage}"
                    onPageLengthChange="{() => {}}">
                </pagination>
            </div>

            <!-- Action buttons -->
            <div class="modal-action justify-end mt-4">
                <button
                    class="btn text-primary rounded-lg"
                    aria-label="{locale?.t('cancel')}"
                    onclick="{handleCancel}">
                    {locale?.t('cancel')}
                </button>
                <button
                    class="btn btn-primary rounded-lg"
                    aria-label="{locale?.t('upload')}"
                    onclick="{handleUpload}">
                    {locale?.t('upload')}
                </button>
            </div>
        </div>

        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}" onclick="{handleCancel}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <!-- Create collection (stacked on top of the upload modal) -->
    <dialog id="preuploadCreateCollectionModal" class="modal" aria-labelledby="preupload-create-collection-heading">
        <div class="modal-box w-1/2 max-w-3xl">
            <form method="dialog">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}"
                        onclick="{closeCreateCollection}">
                    <i class="icon-clear" aria-hidden="true"></i>
                </button>
            </form>

            <h3 id="preupload-create-collection-heading" class="font-bold text-lg mb-2 text-primary">{locale?.t('content_item_addcollection_create')}</h3>

            <div class="space-y-4">
                <div class="form-control">
                    <label class="label" for="preupload-new-collection-name">
                        <span class="label-text font-semibold text-primary mb-2">{locale?.t('title')}:</span>
                    </label>
                    <input id="preupload-new-collection-name"
                           type="text"
                           placeholder="{locale?.t('content_item_addcollection_title_placeholder')}"
                           class="input input-bordered bg-white w-full"
                           value="{state.newCollectionName}"
                           oninput="{updateNewCollectionName}" />
                </div>

                <div class="form-control">
                    <label class="label" for="preupload-new-collection-description">
                        <span class="label-text font-semibold text-primary mb-2">{locale?.t('description')}:</span>
                    </label>
                    <textarea id="preupload-new-collection-description"
                              placeholder="{locale?.t('content_item_addcollection_desc_placeholder')}"
                              class="textarea textarea-bordered bg-white w-full h-32"
                              value="{state.newCollectionDescription}"
                              oninput="{updateNewCollectionDescription}"></textarea>
                </div>

                <p class="text-error text-sm" role="alert" if="{state.createCollectionError}">{state.createCollectionError}</p>

                <div class="modal-action justify-end gap-4 pt-2">
                    <button type="button"
                            class="btn text-primary rounded-lg"
                            aria-label="{locale?.t('cancel')}"
                            onclick="{closeCreateCollection}">{locale?.t('cancel')}</button>
                    <button type="button"
                            class="btn btn-primary rounded-lg"
                            aria-label="{locale?.t('preupload_create_collection_button')}"
                            onclick="{saveNewCollection}">{locale?.t('preupload_create_collection_button')}</button>
                </div>
            </div>
        </div>

        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}" onclick="{closeCreateCollection}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        import pagination from "./pagination.tag"
        import singleSelect from "./single-select.tag"
        import { getCollectionService } from '../services/service-loader';

        export default {
            components: {
                pagination,
                'single-select': singleSelect
            },

            state: {
                files: [],
                metadata: {},
                currentPage: 1,
                pageSize: 5,
                totalPages: 1,
                collections: [],
                collectionsLoaded: false,
                selectedCollectionId: '',
                newCollectionName: '',
                newCollectionDescription: '',
                createCollectionError: null
            },

            /**
             * Show the modal with the given files.
             * Returns a Promise that resolves with { confirmed: true, metadata, collectionId } or { confirmed: false }.
             */
            show(files) {
                this.state.files = [];
                this.state.metadata = {};
                this.state.currentPage = 1;
                this.state.collections = [];
                this.state.collectionsLoaded = false;
                this.state.selectedCollectionId = '';
                this.state.newCollectionName = '';
                this.state.newCollectionDescription = '';
                this.state.createCollectionError = null;
                this.update();

                this.state.files = files;
                this.state.totalPages = Math.ceil(files.length / this.state.pageSize);
                this.update();

                this.$('dialog').showModal();

                this.loadCollections();

                return new Promise((resolve) => {
                    this._resolve = resolve;
                });
            },

            async loadCollections() {
                try {
                    const collectionService = await getCollectionService();
                    const result = await collectionService.get(1, 1000, "resources", "", true);
                    const collections = result?.data || [];
                    this.state.collections = this.tools?.sortCollectionsByName(collections) || collections;
                } catch (err) {
                    this.state.collections = [];
                }
                this.state.collectionsLoaded = true;
                this.update();
            },

            onCollectionSelected(value) {
                this.state.selectedCollectionId = value || '';
                this.update();
            },

            updateNewCollectionName(e) {
                this.state.newCollectionName = e.target.value;
            },

            updateNewCollectionDescription(e) {
                this.state.newCollectionDescription = e.target.value;
            },

            openCreateCollection() {
                this.state.newCollectionName = '';
                this.state.newCollectionDescription = '';
                this.state.createCollectionError = null;
                this.update();
                document.getElementById('preuploadCreateCollectionModal').showModal();
            },

            closeCreateCollection() {
                document.getElementById('preuploadCreateCollectionModal').close();
            },

            async saveNewCollection() {
                this.state.createCollectionError = null;

                const name = this.state.newCollectionName.trim();
                if (!name) {
                    this.state.createCollectionError = this.locale?.t('content_item_addcollection_error_title') || 'Please enter a title.';
                    this.update();
                    return;
                }

                const description = this.state.newCollectionDescription.trim();
                if (!description) {
                    this.state.createCollectionError = this.locale?.t('content_item_addcollection_error_desc') || 'Please enter a description.';
                    this.update();
                    return;
                }

                try {
                    const collectionService = await getCollectionService();
                    const created = await collectionService.post(name, description);
                    const newId = created?.collectionId;
                    if (!newId) {
                        throw new Error('No collectionId returned');
                    }

                    document.getElementById('preuploadCreateCollectionModal').close();
                    await this.loadCollections();
                    this.state.selectedCollectionId = newId;
                    this.update();
                } catch (err) {
                    this.state.createCollectionError =
                        err?.response?.data?.message ||
                        this.locale?.t('preupload_collection_create_error') ||
                        'Failed to create collection.';
                    this.update();
                }
            },

            getCurrentPageItems() {
                const startIndex = (this.state.currentPage - 1) * this.state.pageSize;
                const endIndex = startIndex + this.state.pageSize;
                return this.state.files.slice(startIndex, endIndex);
            },

            changePage(newPage) {
                if (newPage >= 1 && newPage <= this.state.totalPages) {
                    this.state.currentPage = newPage;
                    this.update();
                }
            },

            getMetadataValue(fileName, field) {
                return this.state.metadata[fileName]?.[field] || '';
            },

            updateMetadata(fileName, field, value) {
                if (!this.state.metadata[fileName]) {
                    this.state.metadata[fileName] = {};
                }
                this.state.metadata[fileName][field] = value;
            },

            handleUpload() {
                const collectionId = this.state.selectedCollectionId || null;

                this.$('dialog').close();
                if (this._resolve) {
                    this._resolve({ confirmed: true, metadata: this.state.metadata, collectionId });
                    this._resolve = null;
                }
            },

            handleCancel() {
                this.$('dialog').close();
                if (this._resolve) {
                    this._resolve({ confirmed: false });
                    this._resolve = null;
                }
            },

            async onMounted() {
                window.preUploadFilesModal = this;
            }
        }
    </script>
</pre-upload-files-modal>
